import http from '@/assets/js/interceptor';
// 获取所在部门
export function getDepartMentApi (tplConfigId) {
  return http.get('/instApply/getDepartment', { params: { tplConfigId }, domainType: 'bpmApi' });
}
// 草稿列表
export function getDraftListApi (filter) {
  return http.get('/bpm/getDraft', { params: filter, domainType: 'bpmApi' });
}
// 删除草稿
export function delDraftApi (instApplyId) {
  return http.delete(`/bpm/deleteDraft/${instApplyId}`, { domainType: 'bpmApi' });
}
// 保存草稿
export function saveApprovalDraftApi (data) {
  return http.post('/bpm/saveDraft', data, { domainType: 'bpmApi' });
}
// 提交
export function submitApprovalApi (data) {
  return http.post('/bpm/upsertDraftAndSubmit', data, { domainType: 'bpmApi' });
}
// 表单数据回显
export function getFormJsonDataApi (tplConfigId) {
  return http.get(`/bpm/applyInitInfo/${tplConfigId}`, { domainType: 'bpmApi' });
}
